import * as React from "react";
import { IComponent } from "./IComponent";
import { PageState } from "../services";
import { App } from "./React/App";


export class AppComponent implements IComponent {
    element: Element;
    pageState: PageState;
    component: any;

    async attach(element: Element, pageState: PageState, previousState: any) {
        this.element = element;
        this.pageState = pageState;

        const canCreateCase = (this.element.getAttribute("data-cancreatecase") || "false").toLowerCase() == 'true';
        const canCreateUser = (this.element.getAttribute("data-cancreateuser") || "false").toLowerCase() == 'true';
        const canCreateLab = (this.element.getAttribute("data-cancreatelab") || "false").toLowerCase() == 'true';
        const canEditLab = (this.element.getAttribute("data-caneditlab") || "false").toLowerCase() == 'true';
        const canDeleteCase = (this.element.getAttribute("data-candeletecase") || "false").toLowerCase() == 'true';
        const canManagePopulations = (this.element.getAttribute("data-canmanagepopulations") || "false").toLowerCase() == 'true';

        this.component = pageState.reactRender(<React.StrictMode><App canCreateCase={canCreateCase} canCreateLab={canCreateLab} canEditLab={canEditLab} canDeleteCase={canDeleteCase} canManagePopulations={canManagePopulations} canCreateUser={canCreateUser} /></React.StrictMode>,
            element, undefined);

        if (previousState) {
            this.component.setState(previousState);
        }
    }
    getState() {
        return this.component.state;
    }
}
